export function buildPaymentSpeeds(apiObj: any) {
  const profiles = Array.isArray(apiObj) ? apiObj : Object.values(apiObj);

  return profiles.map((p, idx) => ({
    id: idx,
    label: `${p.name} (${p.discount_rate}% Quick Pay Fee)`,
    value: p.value ?? `ach_${p.payout_days === 0 ? 1 : p.payout_days}_day`,
    day: p.payout_days,
    amount: p.discount_rate
  }));
}
